import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import api from "../../../api";
import { format, formatCurrency } from '../../../functions/functions';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            moneda_nombre: "",     
            cotizacion_pesos: "0,00", 
            fecha_cotizacion: moment(), 
            postVariables: [],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['DETAIL']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            moneda_nombre: "",
            cotizacion_pesos: "0,00", 
            fecha_cotizacion: moment(), 
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(campo => {
            data[campo] = this.state[campo];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                moneda_nombre: data.moneda_nombre,
                cotizacion_pesos: data.cotizacion_pesos, 
                fecha_cotizacion: data.fecha_cotizacion, 
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Cotizacion De La Moneda",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        const { moneda_nombre, cotizacion_pesos, fecha_cotizacion } = this.state;
        const { action } = this.props;
        let vars = this.modalVars();

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.monedas.historial : null)}
                submitUrl={null}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                className="ui-paradigma-modal"
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Cotización registrada</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            label="Fecha Cotización"
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            error={() => this.getError('fecha_cotizacion')}
                            inputComponent={
                                <ParadigmaDatePicker
                                    disabled={vars.disabled}
                                    value={this.state.fecha_cotizacion}
                                    onChange={data => this.onChangeField('fecha_cotizacion', data)}
                                />
                            }
                        />

                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            maxLength={150}
                            label={"Moneda"}
                            value={moneda_nombre}
                            onChange={(e) => this.onChangeField('moneda_nombre', e.target.value)}
                            error={() => this.getError('moneda')}
                        />

                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Cotización (Pesos Argentinos)"}
                                error={() => this.getError('cotizacion_pesos')}
                                inputComponent={
                                    <ParadigmaCurrencyInput
                                        disabled={vars.disabled}
                                        className="form-control monto w-100"
                                        value={formatCurrency(cotizacion_pesos)}
                                        onChange={data => this.onChangeField('cotizacion_pesos', data)}
                                    />
                                }
                            />
                        </div>
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Monedas/Historial/Modal.js